import { FloatButton, Typography } from 'antd';
import React from 'react';
import Logo from '../assets/img/logo.png';
import LightLogo from '../assets/img/Prefectos-light.png';
import { useDarkMode } from '../context/DarkModeContext';

const AuthLayout = ({ title, subtitle, children, className }) => {
  const { isDarkMode, theme, setThemeMode, themeIcon } = useDarkMode();

  const toggleTheme = () => {
    const themeOrder = ['light', 'dark', 'system'];
    const currentIndex = themeOrder.indexOf(theme);
    const newTheme = themeOrder[(currentIndex + 1) % themeOrder.length];
    setThemeMode(newTheme);
  };

  return (
    <div className={`AuthLayout ${className}`}>
      <FloatButton style={{ top: '20px' }} icon={themeIcon} onClick={toggleTheme} />
      <div className="AuthLayout__Container">
        <div className="AuthLayout__Logo">
          <img src={isDarkMode ? LightLogo : Logo} alt="Logo" className="AuthLayout__LogoImage" />
        </div>
        <Typography.Title level={2} className="AuthLayout__Title">
          {title}
        </Typography.Title>
        <Typography.Paragraph className="AuthLayout__Subtitle">{subtitle}</Typography.Paragraph>
        <div className="AuthLayout__Content">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
